module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "masonrygrid",
    staticClass: "masonry-grid"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25fdf646","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Masonry.vue
// module id = 586
// module chunks = 1